
























































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import CreateScheduledFeeRequest from '@/models/Products/ProductFees/CreateScheduledFeeRequest';
import PeriodType from '@/models/Shared/PeriodType';
import ListUtils from '@/lib/listUtils';
import { SubTransactionTypesModule } from '@/store/Products/SubTransactionTypesModule';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'ScheduledFeesDialogForm', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    PeriodType = PeriodType;

    @Prop({ default: false })
    scheduledFee: CreateScheduledFeeRequest

    async beforeMount() {
        await SubTransactionTypesModule.getSubTransactionTypes();
    }

    get periodTypeOptions() {
        return ListUtils.periodTypeOptions();
    }

    get dayOfWeekOptions() {
        return ListUtils.dayOfWeekOptions();
    }

    get dayOfMonthOptions() {
        return ListUtils.dayOfMonthOptions();
    }

    get monthOptions() {
        return ListUtils.monthOptions();
    }

    get subTransactionTypeOptions() {
        return SubTransactionTypesModule.subTransactionTypes;
    }

    get defaultWalletCurrency() {
        return ProductDetailsModule.product.generalSettings.defaultWalletCurrency;
    }

    // Resets valies for postedPeriod based on periodType to avoid sending bad data to API
    @Watch('scheduledFee.periodType')
    async onPostedPeriodTypeChanged(periodType: string) {
        if (periodType === PeriodType.Day) {
            this.scheduledFee.periodOnDayOfWeek = undefined;
            this.scheduledFee.periodOnDayOfMonth = undefined;
            this.scheduledFee.periodOnMonth = undefined;
        }
        if (periodType === PeriodType.Week) {
            this.scheduledFee.periodOnDayOfMonth = undefined;
            this.scheduledFee.periodOnMonth = undefined;
        }
        if (periodType === PeriodType.Month || periodType === PeriodType.Quarter) {
            this.scheduledFee.periodOnDayOfWeek = undefined;
            this.scheduledFee.periodOnMonth = undefined;
        }
        if (periodType === PeriodType.Year) {
            this.scheduledFee.periodOnDayOfWeek = undefined;
        }
    }

}
